// 二代身份证
export const validIDCard = /^[1-9]\d{5}(?:18|19|20)\d{2}(?:0[1-9]|10|11|12)(?:0[1-9]|[1-2]\d|30|31)\d{3}[\dXx]$/
// email(支持中文邮箱)
export const validEmail = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
// 正整数
export const validInteger = /^[1-9]\d*$/
// 手机号校验
export const validPhoneNumber = /^1[3-9]\d{9}$/
// 固话校验02588888888
export const validFixedLine = /^1[3-9]\d{9}$/
// 手机格式校验 或 固话校验02588888888
export const validPhoneAndFixedLine = /^1\d{10}$|^0\d{2,3}[1-9]\d{7}$/
// 密码
export const validPassword = /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\W_!@#$%^&*`~()-+=]+$)(?![0-9\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\W_!@#$%^&*`~()-+=]{8,12}$/
// 两位小数(非必填）
export const validTwoDecimal = /^([1-9][0-9]*|[0-9])(\.\d{0,2})?$/
// 域名
/* eslint-disable no-useless-escape */
export const validDomain = /^(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?$/
// 请输入6-12位，必须包含数字、字母
export const validPassword1 = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,12}$/
export function validateIDCard (rule, value, callback) {
  if (value && !validIDCard.test(value)) {
    callback(new Error('身份证格式错误'))
  } else {
    callback()
  }
}

export function validateEmail (rule, value, callback) {
  if (value && !validEmail.test(value)) {
    callback(new Error('邮箱格式错误'))
  } else {
    callback()
  }
}

export function validateInteger (rule, value, callback) {
  if (value && !validInteger.test(value)) {
    callback(new Error('请输入正整数'))
  } else {
    callback()
  }
}

export function validatePhoneNumber (rule, value, callback) {
  if (value && !validPhoneNumber.test(value)) {
    callback(new Error('手机号格式错误'))
  } else {
    callback()
  }
}

export function validateFixedLine (rule, value, callback) {
  if (value && !validFixedLine.test(value)) {
    callback(new Error('请输入正确固话号码'))
  } else {
    callback()
  }
}

export function validatePhoneAndFixedLine (rule, value, callback) {
  if (value && !validPhoneAndFixedLine.test(value)) {
    callback(new Error('请输入正确号码'))
  } else {
    callback()
  }
}
export function validatelongitude (rule, value, callback) { // 校验经度
  // eslint-disable-next-line no-useless-escape
  const reg = /^(\-|\+)?(((\d|[1-9]\d|1[0-7]\d|0{1,3})\.\d{0,6})|(\d|[1-9]\d|1[0-7]\d|0{1,3})|180\.0{0,6}|180)$/
  if (value !== '' && value !== null && value !== undefined) {
    if (!reg.test(value)) {
      callback(new Error('经度整数部分为0-180,小数部分为0到6位!'))
    } else {
      callback()
    }
  } else {
    callback()
  }
}
export function validatelatitude (rule, value, callback) { // 校验纬度
  // eslint-disable-next-line no-useless-escape
  const reg = /^(\-|\+)?([0-8]?\d{1}\.\d{0,6}|90\.0{0,6}|[0-8]?\d{1}|90)$/
  if (value !== '' && value !== null && value !== undefined) {
    if (!reg.test(value)) {
      callback(new Error('纬度整数部分为0-90,小数部分为0到6位!'))
    } else {
      callback()
    }
  } else {
    callback()
  }
}

// 密码校验(非必填)
export function password (rule, value, callback) {
  if (value && !validPassword.test(value)) {
    callback(new Error('请输入8-12位，必须包含数字、大小字母的三种及以上组合'))
  } else {
    callback()
  }
}

// 密码校验(非必填)
export function password1 (rule, value, callback) {
  if (value && !validPassword1.test(value)) {
    callback(new Error('请输入6-12位，必须包含数字、字母'))
  } else {
    callback()
  }
}

export function twoDecimal (rule, value, callback) {
  if (value && !validTwoDecimal.test(value)) {
    return callback(new Error('请输入两位以内的小数或正整数'))
  } else {
    return callback()
  }
}

// url
export function domain (rule, value, callback) {
  if (value && !validDomain.test(value)) {
    return callback(new Error('请输入正确的域名'))
  } else {
    return callback()
  }
}

// 正整数效验（非必填）
export const pInteger = (rule, value, callback) => {
  const reg = /^[1-9][0-9]*$/
  if (value && !reg.test(value)) {
    return callback(new Error('请输入正整数值'))
  } else {
    return callback()
  }
}

// 一位小数(非必填）
export const oneDecimal = (rule, value, callback) => {
  const reg = /^([1-9][0-9]*|[0-9])(\.\d)?$/
  if (value && !reg.test(value)) {
    return callback(new Error('请输入一位以内的小数或正整数'))
  } else {
    return callback()
  }
}

// (非必填） 手机格式校验
export const phone = (rule, value, callback) => {
  const reg = /^1\d{10}$/
  if (value && !reg.test(value)) {
    return callback(new Error('请输入正确手机号码'))
  } else {
    return callback()
  }
}

// (非必填） 固话校验02588888888
export const fixedLine = (rule, value, callback) => {
  const reg = /^0\d{2,3}[1-9]\d{7}$/
  if (value && !reg.test(value)) {
    return callback(new Error('请输入正确固话号码'))
  } else {
    return callback()
  }
}

// (非必填）手机格式校验 或 固话校验02588888888
export const phoneAndFixedLine = (rule, value, callback) => {
  const reg = /^1\d{10}$|^0\d{2,3}[1-9]\d{7}$/
  if (value && !reg.test(value)) {
    return callback(new Error('请输入正确手机号码或固话号码'))
  } else {
    return callback()
  }
}

// 邮箱格式效验(非必填）
export const email = (rule, value, callback) => {
  const reg = /^[A-z\d_-]+@[A-z\d_-]+\.[A-z\d_-]+$/
  if (value && !reg.test(value)) {
    return callback(new Error('邮箱格式错误'))
  } else {
    return callback()
  }
}

// 身份证格式校验(非必填）
export const idCardNo = (rule, value, callback) => {
  const reg = /(^\d{15}$)|(^\d{17}(\d|X)$)/
  if (value && !reg.test(value)) {
    return callback(new Error('请输入正确的身份证号码'))
  } else {
    return callback()
  }
}

// // 密码校验(非必填)
// export const password = (rule, value, callback) => {
//   const reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,10}$/
//   if (value && !reg.test(value)) {
//     callback(new Error('请输入6-10位英文和数字'))
//   } else {
//     callback()
//   }
// }

// 五个字效验（非必填）
export const minLength5 = (rule, value, callback) => {
  if (value.length < 5) {
    return callback(new Error('最少输入5个字'))
  } else {
    callback()
  }
}

// 两位小数(非必填）不等于零
export const twoDecimalNoZero = (rule, value, callback) => {
  const reg = /^([1-9][0-9]*|[0-9])(\.\d{0,2})?$/
  if (value && (!reg.test(value) || +value === 0)) {
    return callback(new Error('请输入两位以内的小数或正整数'))
  } else {
    return callback()
  }
}

// 1到9999整数
export const treeAgeRules = (rule, value, callback) => {
  const reg = /^[1-9][0-9]*$/
  if (value) {
    if (!reg.test(value) || Number(value) > 9999) {
      return callback(new Error('请输入1到9999整数'))
    } else {
      return callback()
    }
  } else {
    return callback()
  }
}

// 0-100的整数
export const integerWithin = (rule, value, callback) => {
  const reg = /^(0|[1-9][0-9]?|100)$/
  if (value != null && value !== '') {
    if (!reg.test(value)) {
      return callback(new Error('请输入0-100的整数'))
    } else {
      return callback()
    }
  } else {
    return callback()
  }
}
// -40到80的整数
export const validNumberOne = (rule, value, callback) => {
  const reg = /^-?[1-9][0-9]?|0$/
  if (value != null && value !== '') {
    if (!reg.test(value) || Number(value) < -40 || Number(value) > 80) {
      return callback(new Error('请输入-40至80的整数'))
    } else {
      return callback()
    }
  } else {
    return callback()
  }
}

// 0到2000的整数
export const validNumberThree = (rule, value, callback) => {
  const reg = /^[1-9][0-9]*|0$/
  if (value != null && value !== '') {
    if (!reg.test(value) || Number(value) < 0 || Number(value) > 2000) {
      return callback(new Error('请输入0至2000的整数'))
    } else {
      return callback()
    }
  } else {
    return callback()
  }
}

// -2000到2000的整数
export const validNumberFour = (rule, value, callback) => {
  const reg = /^-?[1-9][0-9]*|0$/
  if (value != null && value !== '') {
    if (!reg.test(value) || Number(value) < -2000 || Number(value) > 2000) {
      return callback(new Error('请输入-2000至2000的整数'))
    } else {
      return callback()
    }
  } else {
    return callback()
  }
}

// 校验最小4字符
export const maximum = (rule, value, callback) => {
  if (parseFloat(value) > 999999999.99) {
    return callback(new Error('最大999999999.99'))
  } else {
    return callback()
  }
}

// 校验最小4字符
export const validateMinLength = (rule, value, callback) => {
  if (value && value.length < 4) {
    callback(new Error('最少为4个字符！'))
  } else {
    return callback()
  }
}
